module.exports = __webpack_public_path__ + "img/icon3.b23a4e27.png";